import {computed, observable, makeObservable} from "mobx";
import {StandingsWidgetRowViewModel} from "./standings-widget.row-view-model";
import {STANDINGS_PREVIEW_WIDGET} from "../../standings-preview-widget/standings-preview-widget.consts";
import {STANDINGS_WIDGET} from "../standings-widget.consts";
import {GroupDomainModel} from "../../../domain/common/group/models/group.domain-model";
import {BaseViewModel} from "../../../infrastructure/models/base-view-model";

//TODO: FIX!!!!!!!!! don't extends from GroupApiModel
export class StandingsWidgetGroupedRowsViewModel extends BaseViewModel {
  rows: Array <StandingsWidgetRowViewModel>;
  @observable isCollapsed: Boolean;
  @observable competitorId: Number;
  @observable isStandingsGroup: Boolean;
  @observable hasGroups: Boolean;

  constructor(group: GroupDomainModel, rows: Array<StandingsWidgetRowViewModel>, competitorId: Number, hasStandingsGroup: Boolean, hasGroups: Boolean) {
    super(group);
    this.num = group.num;
    this.rows = rows;
    this.isCollapsed = false;
    this.competitorId = competitorId;
    this.isStandingsGroup = hasStandingsGroup;
    this.hasGroups = hasGroups;

    makeObservable(this);
  }

  @computed get competitorPosition(): Number {
    const competitorPosition: Number = this.rows.filter((row: StandingsWidgetRowViewModel) => row.competitor.id === this.competitorId).first()?.position

    return competitorPosition || STANDINGS_WIDGET.NO_POSITION;
  }

  @computed get isCompetitorStandings(): Boolean {
    return !!this.competitorId;
  }

  @computed get isCompetitorInGroup(): Boolean {
    const isCompetitorInGroup: Boolean = !this.isCompetitorStandings || this.competitorPosition > STANDINGS_WIDGET.NO_POSITION;

    return isCompetitorInGroup;
  }

  @computed get maxStandingRows(): Number {
    const maxStandingRows: Number = this.hasGroups ? STANDINGS_PREVIEW_WIDGET.ROWS.maxGroupStandingRows : STANDINGS_PREVIEW_WIDGET.ROWS.maxStandingsRows;

    return maxStandingRows;
  }

  @computed get previewStandingsRows(): Array<StandingsWidgetRowViewModel> {
    const previewStandingsRows: Array<StandingsWidgetRowViewModel> = this.isCompetitorStandings ? this.filterStandingsRows : this.rows.filter(row => (row.position <= this.maxStandingRows))
    const filteredRows: Array<StandingsWidgetRowViewModel> = this.isCompetitorInGroup ? previewStandingsRows : this.nextStandingGroupRows(previewStandingsRows)

    return filteredRows;
  }

  @computed get filterStandingsRows(): Array<StandingsWidgetRowViewModel> {
    let rows: Array<StandingsWidgetRowViewModel>;
    const isLargeStandingsGroup: Boolean = this.hasGroups && (this.rows.length <= STANDINGS_PREVIEW_WIDGET.ROWS.maxStandingsRows);
    const isTopStandingsRows: Boolean = this.competitorPosition <= STANDINGS_PREVIEW_WIDGET.ROWS.offsetFromCurrentPosition;
    const isLastStandingsRows: Boolean = this.competitorPosition > this.rows.length - STANDINGS_PREVIEW_WIDGET.ROWS.offsetFromCurrentPosition;

    if(isLargeStandingsGroup){
      rows = this.rows;
    } else if(isTopStandingsRows) {
      rows = this.rows.slice(0, STANDINGS_PREVIEW_WIDGET.ROWS.maxStandingsRows)
    } else if(isLastStandingsRows) {
      rows = this.rows.slice(this.rows.length - STANDINGS_PREVIEW_WIDGET.ROWS.maxStandingsRows, this.rows.length)
    } else {
      rows = this.rowsAroundCurrentPosition
    }

    return rows;
  }

  @computed get rowsAroundCurrentPosition(): Array<StandingsWidgetRowViewModel> {
    const offsetFromTop: Number = STANDINGS_PREVIEW_WIDGET.ROWS.offsetFromCurrentPosition + 1;
    const startPosition: Number =this.competitorPosition - offsetFromTop
    const endPosition: Number = this.competitorPosition + STANDINGS_PREVIEW_WIDGET.ROWS.offsetFromCurrentPosition;
    const rowsAroundCurrentPosition: Array<StandingsWidgetRowViewModel> = this.rows.slice(startPosition, endPosition)

    return rowsAroundCurrentPosition
  }

  maxNextStandingGroupRows(previewStandingsRows): Number {
    const maxNextStandingGroupRows: Number = STANDINGS_PREVIEW_WIDGET.ROWS.maxStandingsRows - previewStandingsRows.length

    return maxNextStandingGroupRows;
  }

  nextStandingGroupRows(previewStandingsRows): Array<StandingsWidgetRowViewModel> {
    const nextStandingGroupRows = previewStandingsRows.slice(0, this.maxNextStandingGroupRows(previewStandingsRows));

    return nextStandingGroupRows;
  }
}
